import React from 'react'
const Search = ({ width = 20, height = 20, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3333 8.33464C13.3333 11.0961 11.0947 13.3346 8.33329 13.3346C5.57187 13.3346 3.33329 11.0961 3.33329 8.33464C3.33329 5.57321 5.57187 3.33464 8.33329 3.33464C11.0947 3.33464 13.3333 5.57321 13.3333 8.33464ZM12.4213 13.6012C11.2924 14.4787 9.87389 15.0013 8.33329 15.0013C4.65139 15.0013 1.66663 12.0165 1.66663 8.33464C1.66663 4.65274 4.65139 1.66797 8.33329 1.66797C12.0152 1.66797 15 4.65274 15 8.33464C15 9.87523 14.4774 11.2938 13.5998 12.4227L18.5059 17.3288L17.3274 18.5073L12.4213 13.6012Z"
      fill={color}
    />
  </svg>
)

export default Search
